import get from 'transmute/get';
import { createSelector } from '@reduxjs/toolkit';
const getGdpr = get('gdpr');
export const getConsentToProcessError = createSelector([getGdpr], gdpr => gdpr.consentToProcessError);